import { useState } from "react";
import { fetchMutation, fetchQuery } from "../../../actions";
import {
   CREATE_NOTES,
   CREATE_NOTES_V2,
   DELETE_CREATE_NOTES,
   GET_NOTES_DATA,
   GET_SIGNED_URL_V2,
} from "../actions/notesAct";
import { useEffect } from "react";
import NotesComp from "../component/NotesComp";
import { LIMIT } from "../constent/ConstentVariable";
import { uploadmedia } from "../../../Apimanager/Networking";
import { withRouter } from "react-router";
import { ShowAlert } from "../../../common/alert";
import { errorToDisplay } from "../../../helper/CommonFuncs";
import { toggleLoader } from "../../../redux/actions/globals.action";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { sendDataDogLogs } from "../../notes/actions/notesAct";

const NotesCont = (props) => {
   const {
      history,
      patientId,
      patientDetails,
      setShowButton,
      isVimProvider,
      encounter,
      isDemo = false,
      intitalDemoDone = false,
      setInitialDemo = () => {},
   } = props;
   const [noteId, setNoteId] = useState("");
   const [templateId, setTemplateId] = useState("");
   const [offset, setOffset] = useState(0);
   const [hasMore, setHasMore] = useState(false);
   const [startPolling, setStartPolling] = useState(false);
   const [showTemplateSelection, setShowTemplateSelection] = useState(true);
   const [notesContent, setnotesContent] = useState({
      list: [],
      loading: true,
      notes: { limit: LIMIT, offset: 0 },
   });
   const GetNotes = (search = "", callBack = () => {}, forSearch = false) => {
      return "";
   };
   const createNotes = (generateNote, file) => {
      let notesObj = {
         createNotesV2: { media: generateNote, patientId: patientId, encounterId: encounter },
      };
      sendDataDogLogs("recording-started");
      fetchMutation(
         CREATE_NOTES_V2,
         notesObj,
         (res) => {
            localStorage.setItem("noteIdCurrent", res?.data?.createNotesV2?.notes?.id);
            setNoteId(res?.data?.createNotesV2?.notes?.id);
         },
         () => {
            sendDataDogLogs("recording-error-notes-creation-api-failed");
         }
      );
   };
   const UpdatesNoteStatus = (noteId) => {
      let notesObj = {
         createNotesV2: {
            status: "pending",
            id: noteId,
         },
      };
      fetchMutation(CREATE_NOTES_V2, notesObj, (res) => {});
   };
   const updateNotes = (generateNote) => {
      let notesObj = {
         createNotes: generateNote,
      };
      fetchMutation(CREATE_NOTES, notesObj, (res) => {
         GetNotes("", () => {}, true);
         setNoteId(res?.data?.createNotes?.notes?.id);
      });
   };
   const updateNotesTemp = (generateNote) => {
      let notesObj = {
         createNotes: generateNote,
      };
      setShowTemplateSelection(false);
      fetchMutation(CREATE_NOTES, notesObj, (res) => {
         if (isVimProvider) {
            GetNotes("", () => {}, true);
            setStartPolling(res?.data?.createNotes?.notes?.id);
            props.stopRecordingMain();
         } else {
            history.push("/close_callback");
         }
      });
   };
   const deleteNotes = (noteId, show = true) => {
      let notesObj = {
         createNotes: { id: noteId, isDisable: true },
      };

      fetchMutation(
         DELETE_CREATE_NOTES,
         notesObj,
         (res) => {
            const message = res?.data?.createNotes?.status?.message;
            if (show) {
               ShowAlert(message);
               GetNotes("", () => {}, true);
               history.push("/notes/");
            }
         },
         (error) => {
            ShowAlert(errorToDisplay(error), "error");
         }
      );
   };

   const uploadMediaV2 = (uploadFile, noteId = "", callback = () => {}) => {
      let num = Math.floor(Date.now() / 1000);
      const notesId = noteId || localStorage.getItem("noteIdCurrent");
      let file = "complete-" + num.toString() + ".m4a";
      const isFinal = localStorage.getItem("isFinal") || false;
      if (isFinal) {
         UpdatesNoteStatus(notesId);
         setInitialDemo(true);

         file = "recording-final.m4a";
         localStorage.removeItem("isFinal");
         if (localStorage.getItem("uploadingPending")) {
            setTimeout(() => {
               localStorage.setItem("isFinal", "true");
               uploadMediaV2(uploadFile);
            }, 4000);
            return;
         }

         UpdatesNoteStatus(notesId);
         sendDataDogLogs("recording-uploading-started-final-file");
         // uploadEpicJson(jsonRes, notesId);
         // props.stopRecordingMain();
      } else {
         localStorage.setItem("uploadingPending", "true");
         sendDataDogLogs("recording-uploading-started-complete-file");
      }
      let notesObj = {
         noteId: notesId,
         fileName: file,
      };
      fetchMutation(
         GET_SIGNED_URL_V2,
         notesObj,
         (res) => {
            const url = res?.data?.getCreateNotesSignedUrl?.signedUrl;
            uploadmedia(url, uploadFile)
               .then(() => {
                  localStorage.removeItem("uploadingPending");
                  callback();
                  if (isFinal) {
                     sendDataDogLogs("recording-uploading-completed-final-file");
                  } else {
                     sendDataDogLogs("recording-uploading-completed-complete-file");
                  }
               })
               .catch((error) => {
                  if (isFinal) {
                     sendDataDogLogs("recording-error-uploading-final-file");
                  } else {
                     sendDataDogLogs("recording-error-uploading-complete-file");
                  }
               });
         },
         () => {
            sendDataDogLogs("recording-error-getting-signed-url");
         }
      );
   };

   useEffect(() => {
      // GetNotes();
   }, []);
   return (
      <NotesComp
         setInitialDemo={setInitialDemo}
         isDemo={isDemo}
         intitalDemoDone={intitalDemoDone}
         isVimProvider={isVimProvider}
         stopRecordingMainEpic={props.stopRecordingMain}
         setShowButton={setShowButton}
         patientDetails={patientDetails}
         UpdatesNoteStatus={UpdatesNoteStatus}
         uploadMediaV2={uploadMediaV2}
         setShowTemplateSelection={setShowTemplateSelection}
         showTemplateSelection={showTemplateSelection}
         setStartPolling={setStartPolling}
         startPolling={startPolling}
         deleteNotes={deleteNotes}
         notesContent={notesContent}
         createNotes={createNotes}
         updateNotes={updateNotes}
         GetNotes={GetNotes}
         setnotesContent={setnotesContent}
         noteId={noteId}
         hasMore={hasMore}
         updateNotesTemp={updateNotesTemp}
         templateId={templateId}
         setNoteId={setNoteId}
      />
   );
};

export default withRouter(NotesCont);
